// ---------------------------------------------------------------------
// Cookies
// ---------------------------------------------------------------------

/**
 * @param {string} name
 * @return {?string}
 */
function getCookie (name) {
  var start = document.cookie.indexOf(name + "=");
  var len = start + name.length + 1;
  if ((!start) && (name != document.cookie.substring(0, name.length))) return null;
  if (start == -1) return null;
  var end = document.cookie.indexOf( ";", len );
  if (end == -1) end = document.cookie.length;
  return unescape(document.cookie.substring(len, end));
}

/**
 * @param {string} name
 * @param {string} value
 * @param {?number} expiredays
 */
function setCookie (name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate()+expiredays);
    document.cookie = name + "=" + escape(value) +
    ((expiredays == null) ? "" : ";expires=" + exdate.toUTCString());
}

/**
 * @param {string} name
 */
function deleteCookie (name) {
    setCookie(name, "", -1);
}

// ---------------------------------------------------------------------

window["getCookie"] = getCookie;
window["setCookie"] = setCookie;
window["deleteCookie"] = deleteCookie;

// ---------------------------------------------------------------------
